var _rect, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLgBottomLeftSquares(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_1_1",
    "data-name": "Component 1 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 280,
    height: 282,
    viewBox: "0 0 280 282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 70,
    height: 70,
    transform: "translate(140 72)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 70,
    height: 70,
    transform: "translate(210)",
    fill: "#587bad"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 70,
    height: 70,
    transform: "translate(0 142)",
    fill: "#3d5764"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 70,
    height: 70,
    transform: "translate(70 212)",
    fill: "#adc3c2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLgBottomLeftSquares);
export default __webpack_public_path__ + "static/media/lgBottomLeftSquares.3cc053095ccbc821b260c4e37ba22bc4.svg";
export { ForwardRef as ReactComponent };